<template>
  <div id="agent_login">
    <van-tabs v-model="active" @click="onClickActive" :ellipsis="false" class="agent_admin_tabs" color="#f96624" sticky>
      <van-tab v-for="(item, index) in tab" :key="index">
        <template #title><span>{{ item.title }}</span> </template>
        <van-row class="agent_admin_tab_top" v-if="item.id == 1">
          <!--     充值首页     -->
          <van-col span="22" offset="1">
          <van-col span="11" class="agent_admin_tab_type">
            <van-button :color="isUser ? check_color : color" :plain="isUser ? false : true" block round @click="agent_admin_tab_btn(1,item.id)">{{ $t('agent.user') }}</van-button>
          </van-col>
          <van-col span="11" offset="2" class="agent_admin_tab_type" v-if="is_agent_authority">
            <van-button :color="isUser ? color : check_color" :plain="isUser ? true : false" block round @click="agent_admin_tab_btn(0,item.id)">{{ $t('agent.agent') }}</van-button>
          </van-col>
          </van-col>
          <van-col span="22" offset="1" class="agent_admin_tab_height"> {{ $t('agent.balance') }}({{ diamond }}):</van-col>
          <van-col span="22" offset="1" class="agent_admin_tab_coin">
            <span class="agent_admin_tab_coin_span"> {{ coin }}</span>
          </van-col>
          <van-col span="22" offset="1">
            <van-field v-model="quantity"  :placeholder="$t('agent.Please_enter_quantity')" class="agent_admin_tab_input"/>
          </van-col>
          <van-col span="22" offset="1">
            <van-field v-model="confirmed_quantity"  :placeholder="$t('agent.Please_enter_confirmed_quantity')" class="agent_admin_tab_input"/>
          </van-col>
          <van-col span="12" offset="1">
            <van-field v-model="touid" :placeholder="isUser ? $t('agent.user') + 'ID' : $t('agent.agent') + 'ID'" class="agent_admin_tab_input"/>
          </van-col>
          <van-col span="9" offset="1">
            <van-button :color="check_color" class="agent_admin_search" round block @click="searchBtn"> {{ $t('agent.search') }}</van-button>
          </van-col>
          <van-col span="22" offset="1" class="agent_admin_search_results"> {{ $t('agent.Search_result') }}: <span>
            <img v-if="avatar" :src="avatar" class="agent_admin_search_results_avatar"/> {{ name }}
          </span> </van-col>
          <van-col span="22" offset="1">
            <van-button :color="check_color" class="agent_admin_search" round block @click="ConfirmRecharge">{{ $t('agent.Confirm_recharge') }}</van-button>
          </van-col>
          <van-col span="22" offset="1" class="agent_admin_loginout" @click="logOut"> {{ $t('agent.Log_out') }} </van-col>
          <van-col span="22" offset="1" class="agent_admin_text"> {{ text }} </van-col>
        </van-row>

        <van-row class="agent_admin_tab_top" v-if="item.id == 2">
          <!--     充值记录     -->
          <van-col span="22" offset="1">
            <van-col span="11" class="agent_admin_tab_type">
              <van-button class="button_height" :color="isUser ? check_color : color" :plain="isUser ? false : true" block round @click="agent_admin_tab_btn(1,item.id)">{{ $t('agent.user') }}</van-button>
            </van-col>
            <van-col span="11" offset="2" class="agent_admin_tab_type" v-if="is_agent_authority">
              <van-button class="button_height" :color="isUser ? color : check_color" :plain="isUser ? true : false" block round @click="agent_admin_tab_btn(0,item.id)">{{ $t('agent.agent') }}</van-button>
            </van-col>
          </van-col>
          <van-col span="22" offset="1" class="agent_admin_search_time_top">
            <van-col span="12"> <span style="padding-left: 10px;">{{ $t('agent.total_amount') }} :</span></van-col>
            <van-col span="12" class="agent_admin_search_total_amount"><span style="padding-right: 10px;">{{ totalAmount }}</span></van-col>
          </van-col>
          <van-col span="22" offset="1">
            <van-cell is-link :title="$t('agent.Start_time')" class="agent_admin_search_time" :value="SearchStartTime" @click="SearchTimeShow('SearchStartTime')" />
          </van-col>
          <van-col span="22" offset="1">
            <van-cell is-link :title="$t('agent.End_time')" class="agent_admin_search_time" :value="SearchEndTime" @click="SearchTimeShow('SearchEndTime')" />
          </van-col>
          <van-col span="22" offset="1">
          <van-field
            v-model="SearchUid"
            center
            clearable
            :label="isUser ? $t('agent.user') + 'ID' : $t('agent.agent') + 'ID'"
            :placeholder="isUser ? $t('agent.user') + 'ID' : $t('agent.agent') + 'ID'"
            class="agent_admin_search_user_style"
          >
            <template #button>
              <van-button size="small" round :color="check_color" @click="SearchList"> {{ $t('agent.search') }}</van-button>
            </template>
          </van-field>
          </van-col>



          <van-col span="22" offset="1" class="agent_admin_recharge_top">
            <van-col span="4" class="agent_admin_recharge_type">{{ $t('agent.user')}} ID</van-col>
            <van-col span="8" class="agent_admin_recharge_type">{{ $t('agent.user_name') }}</van-col>
            <van-col span="6" class="agent_admin_recharge_type">{{ $t('agent.recharge_sum') }}</van-col>
            <van-col span="6" class="agent_admin_recharge_type">{{ $t('agent.time') }}</van-col>
          </van-col>
          <van-col span="22" offset="1">
            <van-col span="24" v-for="(item,i) in recharge_list" :key="i" class="agent_admin_recharge_type_list">
              <van-col span="4" class="agent_admin_recharge_type_height">{{ item.uid }}</van-col>
              <van-col span="8" class="agent_admin_recharge_type_height">{{ item.name }}</van-col>
              <van-col span="6" class="agent_admin_recharge_type_height">{{ item.coin }}</van-col>
              <van-col span="6" class="agent_admin_recharge_type_height_time">{{ item.create_time }}</van-col>
            </van-col>
          </van-col>
          <van-col span="22" offset="1" class="agent_admin_page">
            <van-pagination v-model="currentPage" :total-items="total" :items-per-page="limit" :show-page-size="5" prev-text="<" next-text=">" v-if="total" @change="recharge_list_page_btn"/>
          </van-col>
        </van-row>

        <van-row v-if="item.id == 3">
          <van-col span="22" offset="1" class="agent_admin_search_time_top">
            <van-col span="12"> <span style="padding-left: 10px;">{{ $t('agent.total_amount') }} :</span></van-col>
            <van-col span="12" class="agent_admin_search_total_amount"><span style="padding-right: 10px;">{{ totalAmount }}</span></van-col>
          </van-col>
          <van-col span="22" offset="1">
            <van-cell is-link :title="$t('agent.Start_time')" class="agent_admin_search_time" :value="SearchStartTime" @click="SearchTimeShow('SearchStartTime')" />
          </van-col>
          <van-col span="22" offset="1">
            <van-cell is-link :title="$t('agent.End_time')" class="agent_admin_search_time" :value="SearchEndTime" @click="SearchTimeShow('SearchEndTime')" />
          </van-col>
          <!--     收益记录     -->
          <van-col span="22" offset="1" class="agent_admin_income_top">
            <van-col span="8" class="agent_admin_recharge_type">{{ $t('agent.income') }}</van-col>
            <van-col span="8" class="agent_admin_recharge_type">{{ $t('agent.payer') }}</van-col>
            <van-col span="8" class="agent_admin_recharge_type">{{ $t('agent.time') }}</van-col>
          </van-col>
          <van-col span="22" offset="1">
            <van-col span="24" v-for="(item,i) in income_list" :key="i" class="agent_admin_recharge_type_list">
              <van-col span="8" class="agent_admin_recharge_type_height">{{ item.coin }}</van-col>
              <van-col span="8" class="agent_admin_recharge_type_height">{{ item.name ? item.name : $t('agent.platform') }}</van-col>
              <van-col span="8" class="agent_admin_recharge_type_height_time">{{ item.create_time }}</van-col>
            </van-col>
          </van-col>
          <van-col span="22" offset="1" class="agent_admin_page">
            <van-pagination v-model="currentPage" :total-items="total" :items-per-page="limit" :show-page-size="5" prev-text="<" next-text=">" v-if="total" @change="income_list_page_btn"/>
          </van-col>
        </van-row>

        <van-row class="agent_admin_tab_top" v-if="item.id == 4">
          <!--   代理       -->
          <van-col span="22" offset="1">
            <van-col span="18" offset="3" class="agent_admin_tab_type">
              <van-button class="button_height" :color="check_color" :plain="false" block round @click="add_agent_admin_tab_btn('')">{{ $t('agent.Add_agent') }}</van-button>
            </van-col>
          </van-col>
          <van-col span="22" offset="1" class="agent_admin_recharge_top">
            <van-col span="8" class="agent_admin_recharge_type">{{ $t('agent.Agent_name') }}(ID)</van-col>
            <van-col span="6" class="agent_admin_recharge_type">{{ $t('agent.balance') }}</van-col>
            <van-col span="6" class="agent_admin_recharge_type">{{ $t('agent.status') }}</van-col>
            <van-col span="4" class="agent_admin_recharge_type">{{ $t('agent.operation') }}</van-col>
          </van-col>
          <van-col span="22" offset="1">
            <van-col span="24" v-for="(item,i) in agency_list" :key="i" class="agent_admin_recharge_type_list">
              <van-col span="8" class="agent_admin_recharge_type_height">{{ item.name }}({{ item.id }})</van-col>
              <van-col span="6" class="agent_admin_recharge_type_height">{{ item.coin }}</van-col>
              <van-col span="6" class="agent_admin_recharge_type_height" v-if="item.status">{{ item.status == 1 ? $t('other.open') : $t('other.close') }}</van-col>
              <van-col span="6" class="agent_admin_recharge_type_height" v-else>{{ $t('other.under_review') }}</van-col>
              <van-col span="4" class="agent_admin_recharge_type_height" @click="add_agent_admin_tab_btn(i)"><van-icon name="edit" color="#f96624" size="14"/></van-col>
            </van-col>
          </van-col>
          <van-col span="22" offset="1" class="agent_admin_page">
            <van-pagination v-model="currentPage" :total-items="total" :items-per-page="limit" :show-page-size="5" prev-text="<" next-text=">" v-if="total" @change="agency_list_page_btn"/>
          </van-col>
        </van-row>
      </van-tab>
    </van-tabs>
    <van-popup v-model="agencyShow" position="bottom" :style="{ height: '70%' }">
      <van-col span="24" class="create_agency_title">{{ $t('agent.agent') }}</van-col>
      <van-form @submit="onSubmit">
        <van-field
          v-model="form.username"
          name="username"
          :label="$t('agent.Agent_name')"
          :placeholder="$t('agent.Agent_name')"
        />
        <van-field
          v-model="form.account"
          name="account"
          :label="$t('agent.account')"
          :placeholder="$t('agent.enter_account')"
          :rules="[{ required: true, message: $t('agent.enter_account') }]"
        />
        <van-field
          v-model="form.password"
          type="password"
          name="password"
          :label="$t('agent.password')"
          :placeholder="$t('agent.enter_password')"
          :rules="[{ required: true, message: $t('agent.enter_password') }]"
        />
        <van-field
          v-model="form.confirm_password"
          type="password"
          name="confirm_password"
          :label="$t('agent.confirm_password')"
          :placeholder="$t('agent.confirm_password')"
        />
<!--        <van-field name="status" :label="$t('agent.status')">-->
<!--          <template #input>-->
<!--            <van-switch v-model="form.status" size="20" />-->
<!--          </template>-->
<!--        </van-field>-->
        <div style="margin: 16px;">
          <van-button class="button_height"  :color="check_color" round block native-type="submit">{{ $t('btn.confirm') }}</van-button>
        </div>
      </van-form>
    </van-popup>
    <van-action-sheet v-model="TimeShow">
      <van-datetime-picker
        v-model="currentDate"
        type="date"
        :title="$t('agent.Year_month_day')"
        :min-date="minDate"
        :max-date="maxDate"
        :confirm-button-text="$t('btn.confirm')"
        :cancel-button-text="$t('btn.cancel')"
        @confirm="onConfirmDate"
        @cancel="TimeShow = false"
      />
    </van-action-sheet>
  </div>
</template>

<script>

import '@/assets/css/style.css'
import axios from 'axios'
import Toast from "vant/lib/toast"
import { Dialog, Notify } from 'vant'

export default {
  data() {
    return {
      tab: [],
      active: 0,
      check_color: 'linear-gradient(#f96624, #f96624)',
      color: '#f96624',
      isUser: true,
      diamond: undefined,
      coin: undefined,
      name: undefined,
      avatar: undefined,
      to_id: undefined,
      quantity: undefined,
      confirmed_quantity: undefined,
      touid: undefined,
      text: undefined,
      SearchUid: undefined,
      recharge_list: [],
      income_list: [],
      agency_list: [],
      currentPage: 0,
      total: 0,
      limit: 15,
      agencyShow: false,
      form: {
        id: undefined,
        username: '',
        account: '',
        password: '',
        confirm_password: '',
        status: false
      },
      is_agent_authority: 0,
      minDate: new Date(2020, 0, 1),
      maxDate: new Date(2025, 10, 1),
      currentDate: new Date(2021, 0, 17),
      TimeShow: false,
      SearchStartTime: undefined,
      SearchEndTime: undefined,
      SearchName: undefined,
      totalAmount: undefined
    }
  },
  created: function() {
    this.is_agent_authority = localStorage.getItem('is_agent_authority') == 1 ? 1 : 0
    this.getTag()
    this.get_index()
    document.title = this.$t('agent.agent_platform')
  },
  components: {
    [Dialog.name]: Dialog,
    [Notify.name]: Notify
  },
  methods: {
    SearchList() {
      if (this.active == 1) {
        this.currentPage = 0
        this.totalAmount = 0
        this.get_recharge_list()
      } else {
        this.currentPage = 0
        this.totalAmount = 0
        this.get_income_list()
      }
    },
    SearchTimeShow(name) {
      this.SearchName = name
      this.TimeShow = true
    },
    onConfirmDate(d) {
      if (this.SearchName == 'SearchStartTime') {
        this.SearchStartTime = this.timeFormat(d)
      } else if (this.SearchName == 'SearchEndTime') {
        this.SearchEndTime = this.timeFormat(d)
      }
      if (this.active == 2) {
        this.currentPage = 0
        this.get_income_list()
      }
      this.TimeShow = false
    },
    timeFormat(time) { //时间格式化 2019-09-08
      let year = time.getFullYear();
      let month = time.getMonth() + 1;
      let day = time.getDate();
      return year + '-' + month + '-' +day;
    },
    onSubmit(params) {
      console.log('submit', params);
      const token = localStorage.getItem('agentAdminToken')
      this.form.token = token
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=agent_admin&act=register_agency", {
        params: {
          id: this.form.id,
          username: this.form.username,
          account: this.form.account,
          password: this.form.password,
          confirm_password: this.form.confirm_password,
          token: token
        }
      }).then(res => {
        console.log(res.data.error)
        Toast(res.data.error)
        if (res.data.status === 1) {
          this.agencyShow = false
          this.currentPage = 0
          this.get_agency_list()
        } else if(res.data.status === 2) {
          // 删除缓存
          localStorage.removeItem('agentAdminToken')
          setTimeout(()=>{
            // 跳转登录
            this.$router.push({ path: '/agent_login' })
          },2000)
        }
      })
    },
    get_index() {
      const token = localStorage.getItem('agentAdminToken')
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=agent_admin&act=get_index", {
        params: {
          token: token
        }
      }).then(res => {

        if (res.data.status === 1) {
          this.coin = res.data.data.coin
          this.diamond = res.data.data.diamond
          this.text = res.data.data.text
        } else if(res.data.status === 2) {
          Toast(res.data.error)
          // 删除缓存
          localStorage.removeItem('agentAdminToken')
          setTimeout(()=>{
            // 跳转登录
            this.$router.push({ path: '/agent_login' })
          },2000)
        }else{
          Toast(res.data.error)
        }
      })
    },
    get_recharge_list() {
      const token = localStorage.getItem('agentAdminToken')
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=agent_admin&act=user_recharge_log", {
        params: {
          token: token,
          page: this.currentPage,
          type: this.isUser ? 2 : 1,
          StartTime: this.SearchStartTime,
          EndTime: this.SearchEndTime,
          SearchUid: this.SearchUid,
          limit: this.limit
        }
      }).then(res => {
        console.log()
        if (res.data.status === 1) {
          this.recharge_list = res.data.data.list
          this.currentPage = res.data.data.currentPage
          this.total = res.data.data.total > this.limit ? res.data.data.total : 0
          this.totalAmount = res.data.data.totalAmount
        } else if(res.data.status === 2) {
          Toast(res.data.error)
          // 删除缓存
          localStorage.removeItem('agentAdminToken')
          setTimeout(()=>{
            // 跳转登录
            this.$router.push({ path: '/agent_login' })
          },2000)
        } else {
          Toast(res.data.error)
        }
      })
    },
    get_income_list() {
      const token = localStorage.getItem('agentAdminToken')
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=agent_admin&act=user_income_log", {
        params: {
          token: token,
          page: this.currentPage,
          StartTime: this.SearchStartTime,
          EndTime: this.SearchEndTime,
          SearchUid: this.SearchUid,
          limit: this.limit
        }
      }).then(res => {
        console.log()
        if (res.data.status === 1) {
          this.income_list = res.data.data.list
          this.currentPage = res.data.data.currentPage
          this.total = res.data.data.total > this.limit ? res.data.data.total : 0
          this.totalAmount = res.data.data.totalAmount
        } else if(res.data.status === 2) {
          Toast(res.data.error)
          // 删除缓存
          localStorage.removeItem('agentAdminToken')
          setTimeout(()=>{
            // 跳转登录
            this.$router.push({ path: '/agent_login' })
          },2000)
        } else {
          Toast(res.data.error)
        }
      })
    },
    get_agency_list() {
      const token = localStorage.getItem('agentAdminToken')
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=agent_admin&act=agency_list", {
        params: {
          token: token,
          page: this.currentPage,
          limit: this.limit
        }
      }).then(res => {
        console.log()
        if (res.data.status === 1) {
          this.agency_list = res.data.data.list
          this.currentPage = res.data.data.currentPage
          this.total = res.data.data.total > this.limit ? res.data.data.total : 0
        } else if(res.data.status === 2) {
          Toast(res.data.error)
          // 删除缓存
          localStorage.removeItem('agentAdminToken')
          setTimeout(()=>{
            // 跳转登录
            this.$router.push({ path: '/agent_login' })
          },2000)
        } else {
          Toast(res.data.error)
        }
      })
    },
    agent_admin_tab_btn(i,id) {
      this.isUser = i === 1
      this.SearchUid = undefined
      if (id === 1) {
        this.name = ''
        this.touid = undefined
        this.to_id = undefined
      } else if (id === 2) {
        this.currentPage = 0
        this.get_recharge_list()
      }
    },
    searchBtn() {
      const token = localStorage.getItem('agentAdminToken')
      axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=agent_admin&act=detection_user", {
        params: {
          token: token,
          touid: this.touid,
          type: this.isUser ? 2 : 1
        }
      }).then(res => {
        console.log()
        if (res.data.status === 1) {
          this.name = res.data.data.nick_name
          this.to_id = res.data.data.id
          this.avatar = res.data.data.avatar
        } else if(res.data.status === 2) {
          Toast(res.data.error)
          // 删除缓存
          localStorage.removeItem('agentAdminToken')
          setTimeout(()=>{
            // 跳转登录
            this.$router.push({ path: '/agent_login' })
          },2000)
        } else {
          Toast(res.data.error)
        }
      })
    },
    getTag(){

      let j = 3
      if (this.is_agent_authority) {
        j = 4
      }

      for(let i=1; i <= j; i++ ) {
        let title = ''
        if (i == 1) {
          title = this.$t('agent.recharge')
        } else if (i == 2) {
          title = this.$t('agent.consumption')
        } else if (i == 3) {
          title = this.$t('agent.income')
        } else{
          title = this.$t('agent.agent')
        }
        this.tab.push({id: i, title: title})
      }
    },
    logOut() {
      // 退出登录
      Dialog.confirm({
        title: this.$t('agent.Log_out'),
        message: this.$t('agent.Whether_log_out'),
      }).then(() => {
          // on confirm 删除缓存
        localStorage.removeItem('agentAdminToken')
        // 跳转登录
        this.$router.push({ path: '/agent_login' })
      }).catch(() => {
          // on cancel
      })
    },
    ConfirmRecharge() {
      if( this.quantity === undefined || this.quantity <= 0){
        Notify({ type: 'danger', message: this.$t('agent.Please_enter_quantity') })
        return false
      }
      if( this.confirmed_quantity === undefined || this.confirmed_quantity === '' ||  this.quantity != this.confirmed_quantity){
        Notify({ type: 'danger', message: this.$t('agent.Please_enter_confirmed_quantity') })
        return false
      }
      if( this.name === undefined || this.name === ''){
        Notify({ type: 'danger', message: this.$t('agent.Please_enter_account_id') })
        return false
      }

      Dialog.confirm({
        title: this.name,
        message: this.$t('agent.recharge') + ":" + this.quantity + " ?",
        confirmButtonText: this.$t('btn.confirm'),
        cancelButtonText: this.$t('btn.cancel'),
      }).then(() => {
        const token = localStorage.getItem('agentAdminToken')
        axios.get(this.baseUrlApi + this.baseUrlPath + "?ctl=agent_admin&act=user_recharge", {
          params: {
            token: token,
            touid: this.to_id,
            type: this.isUser == true ? 2 : 1,
            coin: this.quantity,
            confirmed_coin: this.confirmed_quantity
          }
        }).then(res => {
          console.log()
          Toast(res.data.error)
          if (res.data.status === 1) {
            this.touid = undefined
            this.to_id = undefined
            this.quantity = undefined
            this.confirmed_quantity = undefined
            this.name = undefined
            this.get_index()
          } else if(res.data.status === 2) {
            // 删除缓存
            localStorage.removeItem('agentAdminToken')
            setTimeout(()=>{
              // 跳转登录
              this.$router.push({ path: '/agent_login' })
            },2000)
          }
        })
      }).catch(() => {
        // on cancel
      })
    },
    recharge_list_page_btn(i) {
      this.currentPage = i - 1
      console.log(i)
      this.get_recharge_list()
    },
    income_list_page_btn(i){
      this.currentPage = i - 1
      console.log(i)
      this.get_income_list()
    },
    agency_list_page_btn(i){
      this.currentPage = i - 1
      console.log(i)
      this.get_agency_list()
    },
    onClickActive(name, title) {
      this.active = name
      this.SearchStartTime = undefined
      this.SearchEndTime = undefined
      this.SearchUid = undefined
      this.totalAmount = undefined
      if (this.active == 0) {
        this.isUser = true
        this.get_index()
      } else if (this.active == 1) {
        this.currentPage = 0
        this.isUser = true
        this.get_recharge_list()
      } else if (this.active == 2) {
        this.currentPage = 0
        this.get_income_list()
      } else {
        this.currentPage = 0
        this.get_agency_list()
      }
      console.log(name)
    },
    add_agent_admin_tab_btn(i) {
      if (i >= '0') {
        this.form = {
          id: this.agency_list[i].id,
          username: this.agency_list[i].name,
          account: this.agency_list[i].login,
          password: '',
          confirm_password: '',
          status: this.agency_list[i].status == 1 ? true : false,
        }
      } else {
        this.form = {
          id: undefined,
          username: '',
          account: '',
          password: '',
          confirm_password: '',
          status: false
        }
      }
      // 添加代理
      this.agencyShow = true

    },
  }
}
</script>



// WEBPACK FOOTER //
// src/components/agent_admin.vue